module.exports = __webpack_public_path__ + "static/media/cancel-payment-source.8596f0d6.png";